import { render, staticRenderFns } from "./TiendaOnline.vue?vue&type=template&id=b91e75c8&scoped=true"
import script from "./TiendaOnline.vue?vue&type=script&lang=js"
export * from "./TiendaOnline.vue?vue&type=script&lang=js"
import style0 from "./TiendaOnline.vue?vue&type=style&index=0&id=b91e75c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91e75c8",
  null
  
)

export default component.exports